import { render, staticRenderFns } from "./__TemLoi.vue?vue&type=template&id=956853de&"
import script from "./__TemLoi.vue?vue&type=script&lang=js&"
export * from "./__TemLoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports